module.exports = __webpack_public_path__ + "static/media/icon-comment.066f885e.svg";